import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CookieHandler from '../pages/LandingPage/Authentication/CookieHandler';

const GetRequest = async (path, isAuthenticated) => {
  let headers = {
    'Content-Type': 'application/json'
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('API URL:', apiUrl);

  if (isAuthenticated) {
    const token = CookieHandler.getCookie('token');
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  try {
    const response = await axios.get(apiUrl + `/api/${path}`, { headers });
    return response;
  } catch (error) {
    console.error('Error in GetRequest:', error); 
    throw new Error('user not found');
  }
};

export default GetRequest;
